module.exports = __webpack_public_path__ + "static/media/natours_small.43cad584.png";